import { Controller, useFormContext } from 'react-hook-form';

import WsCustomRangeSlider, { MarkValueProps } from './WsCustomRangeSlider';

interface RelavanceRangeSliderProps {
  name: string;
  title: string;
  marks: MarkValueProps[];
}

const RelavanceSlider: React.FC<RelavanceRangeSliderProps> = ({ name, title, marks }) => {
  const { control, setValue } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => (
        <WsCustomRangeSlider
          value={value}
          onChange={(newValue) => setValue(name, [newValue[0], value[1]])}
          marks={marks}
          title={title}
          min={marks[0].value}
          max={marks[marks.length - 1].value}
        />
      )}
    />
  );
};

export default RelavanceSlider;
